import React, { useContext } from "react";
import { TableCell } from "@amzn/meridian/table";
import { formatTime } from "../SettingsUtil";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import "../styles/OpsClockView.css";
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon";
import { SettingsContext } from "./SettingsContext";
import { startTime } from "../SettingsConstant";
import { endTime } from "./SettingsConstant";

const BreaksData = ({
  breakEvent,
  currentStartTime,
  currentEndTime,
  oldStartTime,
  oldEndTime,
  breakType,
  timeZone,
  dispatchDate,
  index,
  handleBreakDelete,
  updatedBreaks,
  isUserAuthorisedForSettingsEdit,
}) => {
  const { dispatch } = useContext(SettingsContext);
  let oldStartDate = oldStartTime ? new Date(oldStartTime * 1000) : null;
  let oldEndDate = oldEndTime ? new Date(oldEndTime * 1000) : null;
  let currentStartDate = currentStartTime
    ? new Date(currentStartTime * 1000)
    : null;
  let currentEndDate = currentEndTime ? new Date(currentEndTime * 1000) : null;
  let oldStartDateTimeString = oldStartDate
    ? oldStartDate.toLocaleString("en-US", { timeZone })
    : null;
  let oldEndDateTimeString = oldEndDate
    ? oldEndDate.toLocaleString("en-US", { timeZone })
    : null;
  let currentStartDateTimeString = currentStartTime
    ? currentStartDate.toLocaleString("en-US", { timeZone })
    : dispatchDate;
  let currentEndDateTimeString = currentEndTime
    ? currentEndDate.toLocaleString("en-US", { timeZone })
    : dispatchDate;

  const onChange = (value, timeType) => {
    let newTime = value ? value.format("HH:mm") : "";

    let timeObj = {
      newTime: newTime,
      currentTime: timeType === startTime ? currentStartTime : currentEndTime,
      currentDateTimeString:
        timeType === startTime
          ? currentStartDateTimeString
          : currentEndDateTimeString,
      timeType: timeType,
    };

    if (updatedBreaks[index]) {
      updatedBreaks = [
        ...updatedBreaks,
        ...updatedBreaks[index],
        (updatedBreaks[index][timeType] = timeObj),
      ];
    } else {
      updatedBreaks[index] = {
        [timeType]: timeObj,
      };
    }
  };

  const renderTimePicker = (timeType) => {
    return (
      <TimePicker
        showSecond={false}
        timeOnly={true}
        minuteStep={15}
        width={250}
        showIcon={false}
        placeholder="HH:MM"
        onChange={(value) => onChange(value, timeType)}
        focusOnOpen={true}
        disabled={!isUserAuthorisedForSettingsEdit}
      />
    );
  };

  return (
    <React.Fragment>
      <TableCell>
        <div className="process">
          <span className="processName">
            {breakEvent.breakName && breakEvent.breakName.toLowerCase()}
          </span>
        </div>
      </TableCell>

      <TableCell>
        {" "}
        <span className="breakType">
          {breakType && breakType.toLowerCase()}
        </span>
      </TableCell>

      <TableCell>
        {oldStartDateTimeString ? formatTime(oldStartDateTimeString) : "N/A"}
      </TableCell>
      <TableCell> {renderTimePicker(startTime)} </TableCell>

      <TableCell>
        {oldEndDateTimeString ? formatTime(oldEndDateTimeString) : "N/A"}
      </TableCell>
      <TableCell> {renderTimePicker(endTime)} </TableCell>
      <TableCell>
        {isUserAuthorisedForSettingsEdit ? (
          <div
            onClick={() =>
              dispatch({ type: "OPEN_DELETE_BREAK_MODAL", data: index })
            }
          >
            <Text className="deleteBreak" color={"error"}>
              <Icon tokens={trashTokens} />
            </Text>
          </div>
        ) : (
          ""
        )}
      </TableCell>
    </React.Fragment>
  );
};

export default BreaksData;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/BreaksData.js